import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
const SalesBroadCastMessageList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);

  const { sendRequest: deleteHolidays } = useHttp();

  const deleteOperation = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Holidays detail?",
      onOk() {
        const updatedApproveData = {
          ...data,
          status: 0,
        };

        deleteHolidays(
          {
            url: "/api/bankDetail/",
            method: "PUT",
            body: updatedApproveData,
          },
          (data) => {
            toast.success("Data deleted successfully");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/getallnotifications?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        //console.log("NOtificatin Data", res);
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.accountGroupName?.includes(filetrtext) ||
        item?.accountGroupcode?.includes(filetrtext) ||
        item?.accountHead?.includes(filetrtext) ||
        item?.accountSubGroupName?.includes(filetrtext) ||
        item?.accountSubGroupCode?.includes(filetrtext) ||
        item?.accountCode?.includes(filetrtext) ||
        item?.accountName?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3"> &nbsp; &nbsp;Message Broadcast Detail </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Message Broadcast
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th> Date</th>
                            <th> Time</th>
                            <th> Subject</th>

                            <th> Message</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.broadcastDate}</td>
                                <td>{x.broadcastTime}</td>
                                <td>{x.messageSubject}</td>
                                <td>{x.messageBody}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SalesBroadCastMessageList;
